/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { of } from 'rxjs/observable/of';

/**
 * Default error handler
 */
@Injectable()
export class ErrorHandler {
  public handleError(errorResponse: HttpErrorResponse): Observable<any> {
    //return //throwError(errorResponse.error.error || 'Server error');
    return of(errorResponse.error.message)
  }
}



// WEBPACK FOOTER //
// ./src/services/lbsdk/services/core/error.service.ts